
import { supabase } from '@/integrations/supabase/client';

export const CustomCategoryService = {
  // Get all categories for a user (default + custom)
  async getUserCategories(userId: string) {
    const defaultCategories = ['personal', 'family', 'health', 'work', 'community', 'thanksgiving', 'urgent', 'general'];
    
    const { data: customCategories, error } = await supabase
      .from('custom_categories')
      .select('name')
      .eq('user_id', userId)
      .order('created_at', { ascending: true });

    if (error) {
      console.error('Error fetching custom categories:', error);
      return defaultCategories;
    }

    const customCategoryNames = customCategories?.map(cat => cat.name) || [];
    return [...defaultCategories, ...customCategoryNames];
  },

  // Add a new custom category for a user
  async addCustomCategory(userId: string, categoryName: string) {
    const { data, error } = await supabase
      .from('custom_categories')
      .insert([{ user_id: userId, name: categoryName }])
      .select()
      .single();

    if (error) {
      console.error('Error adding custom category:', error);
      throw error;
    }

    return data;
  }
};
